// src/utils/pwaDetection.js - NEW FILE

/**
 * Detects if the app is running as a PWA (installed app)
 */
export const isPWA = () => {
  // Check if running in standalone mode (installed PWA)
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
  
  // iOS Safari detection
  const isIOSStandalone = window.navigator.standalone === true;
  
  // Android TWA (Trusted Web Activity) detection
  const isTWA = document.referrer.includes('android-app://');
  
  return isStandalone || isIOSStandalone || isTWA;
};

/**
 * Detects the platform the PWA is running on
 */
export const getPWAPlatform = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
  // iOS detection
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'ios';
  }
  
  // Android detection
  if (/android/i.test(userAgent)) {
    return 'android';
  }
  
  // Desktop PWA
  if (navigator.userAgentData?.platform || navigator.platform) {
    const platform = navigator.userAgentData?.platform || navigator.platform;
    if (/Win/.test(platform)) return 'windows';
    if (/Mac/.test(platform)) return 'macos';
    if (/Linux/.test(platform)) return 'linux';
  }
  
  return 'unknown';
};

/**
 * Check if the app was recently updated
 */
export const checkPWAVersion = () => {
  const currentVersion = process.env.REACT_APP_VERSION || '1.0.0';
  const storedVersion = localStorage.getItem('pwa_version');
  
  if (storedVersion !== currentVersion) {
    localStorage.setItem('pwa_version', currentVersion);
    return { updated: true, oldVersion: storedVersion, newVersion: currentVersion };
  }
  
  return { updated: false, currentVersion };
};

/**
 * Log PWA session information
 */
export const logPWASession = () => {
  const sessionData = {
    isPWA: isPWA(),
    platform: getPWAPlatform(),
    timestamp: new Date().toISOString(),
    displayMode: window.matchMedia('(display-mode: standalone)').matches ? 'standalone' : 'browser',
    userAgent: navigator.userAgent
  };
  
  console.log('📱 PWA Session Info:', sessionData);
  
  return sessionData;
};

/**
 * Store PWA session metadata
 */
export const storePWASession = () => {
  const sessionData = logPWASession();
  localStorage.setItem('pwa_session', JSON.stringify(sessionData));
  localStorage.setItem('pwa_last_active', Date.now().toString());
};

/**
 * Check if PWA session is still valid (within 7 days)
 */
export const isPWASessionValid = () => {
  const lastActive = localStorage.getItem('pwa_last_active');
  if (!lastActive) return false;
  
  const daysSinceActive = (Date.now() - parseInt(lastActive)) / (1000 * 60 * 60 * 24);
  return daysSinceActive < 7;
};